module.exports = __webpack_public_path__ + "img/gift.3d9b8e39.png";